<template>
<div class="chapter">
<div class="inner_page">
<div class="chaptitle"><span><a id="pagexiii"></a><b>MAPS</b></span></div>
<div class="fig"><span><a href="#/ch01#rfig1" id="fig1">Figure 1.  The Confederate Trans-Mississippi</a></span></div>
<div class="fig"><span><span href="#/ch05#rfig2" id="fig2" title="Link target outside of Sample">Figure 2.  Union and Confederate Lines of March during the Prairie Grove Campaign, December 3–December 6, 1862</span></span></div>
<div class="fig"><span><span href="#/ch05#rfig3" id="fig3" title="Link target outside of Sample">Figure 3.  The Battle of Prairie Grove, December 7, 1862</span></span></div>
<div class="fig"><span><span href="#/ch06#rfig4" id="fig4" title="Link target outside of Sample">Figure 4.  Marmaduke’s First Missouri Raid</span></span></div>
<div class="fig"><span><span href="#/ch06#rfig5" id="fig5" title="Link target outside of Sample">Figure 5.  Marmaduke’s Cape Girardeau Raid</span></span></div>
<div class="fig"><span><span href="#/ch06#rfig6" id="fig6" title="Link target outside of Sample">Figure 6.  Shelby’s Missouri Raid</span></span></div>
<div class="fig"><span><span href="#/ch06#rfig7" id="fig7" title="Link target outside of Sample">Figure 7.  Price’s Missouri Expedition</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?290d39f0